import React from 'react';
import {connect} from 'react-redux';
import {Map, List} from 'immutable';
import SVG from 'react-inlinesvg';
import { CSVLink} from "react-csv";
import {Area, ResponsiveContainer} from 'recharts';
import {AreaChart, CartesianGrid, XAxis, YAxis, Tooltip} from 'recharts';

import {Flex, SVGButton, Arrow, TextButton, UpgradeModal, TicketActivity, RatingStats} from '/app/src/component';
import DateTime from '/app/src/lib/DateTime'
import PaymentConfigHandler from '/app/src/config/PaymentConfigHandler'
import {history} from '/app/src/store'

import CompanyModel from '/app/src/model/Company/model';
import SystemModel from '/app/src/model/System/model';
import EmployeeSelector from '/app/src/model/Employee/selector';
import UserSelector from '/app/src/model/User/selector';
import WithPaymentPermission from '/app/src/hoc/withPaymentPermission'
import ConversationSelector from '/app/src/model/Conversation/selector';

import StatisticsUpgradeText from './StatisticsUpgradeText';
import FeedbackOverView from './Feedback';
import style from './style.css'

const StatisticsUpgradeTextWrapper = (props) => {
    const hasAccess = PaymentConfigHandler.checkAccess('stats-responseGraph', 'read')
    if (hasAccess === 0) {
        return (
            <StatisticsUpgradeText {...props}/>
        )
    }
    return null
}

const statisticsUpgradeText = {
    width: "100%",
    hAlignContent: "right",
    padding: "15px"
}

class DashboardOverview extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            ticketCreatedConfig: {
                'unit': 'week',
                'info': {
                    'year': new Date().getFullYear(),
                    'week': DateTime.getCurrentWeek()
                }
            },
            ticketResponseConfig: {
                'unit': 'week',
                'info': {
                    'year': new Date().getFullYear(),
                    'week': DateTime.getCurrentWeek()
                }
            },
            companyResponseTime: this.props.companyResponseTime,
            showModal: false
        }
        this._renderLiveStats = this._renderLiveStats.bind(this)

        this._ActivityGraph = this._ActivityGraph.bind(this)
        this.__ticketCreatedButtonOnClick = this.__ticketCreatedButtonOnClick.bind(this)
        this.__renderUnitButtonForActivityGraph = this.__renderUnitButtonForActivityGraph.bind(this)
        this.____renderYearActivityButton= this.____renderYearActivityButton.bind(this)
        this.____renderMonthActivityButton = this.____renderMonthActivityButton.bind(this)
        this.____renderWeekActivityButton = this.____renderWeekActivityButton.bind(this)
        this.____renderDayActivityButton = this.____renderDayActivityButton.bind(this)

        this._ResponseGraph = this._ResponseGraph.bind(this)
        this.__renderUnitButtonForResponseGraph = this.__renderUnitButtonForResponseGraph.bind(this)
        this.__ticketResponseButtonOnClick = this.__ticketResponseButtonOnClick.bind(this)
        this.____renderYearResponseButton= this.____renderYearResponseButton.bind(this)
        this.____renderMonthResponseButton = this.____renderMonthResponseButton.bind(this)
        this.____renderWeekResponseButton = this.____renderWeekResponseButton.bind(this)
        this.____renderDayResponseButton = this.____renderDayResponseButton.bind(this)
    }
    componentDidMount(){
        this.props.dispatch(
            CompanyModel.statsLive()
        )
        this.props.dispatch(
            CompanyModel.statsTicketCreatedReadExact(this.state.ticketCreatedConfig['unit'], this.state.ticketCreatedConfig['info'])
        );
        this.props.dispatch(
            CompanyModel.statsTicketResponseTimeReadExact(this.state.ticketResponseConfig['unit'], this.state.ticketResponseConfig['info'])
        );
    }

    _renderLiveStats(){

        let time = this.state.companyResponseTime
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time - hours*3600)/60);
        const seconds = time - hours*3600  - minutes*60;

        return (<React.Fragment>

                <Flex borderBottom='1px solid' color='lightgrey' column w='80%' mt='30px' shrink={0}>
                    <Flex fontSize='25px' fontWeight='bold' color='black'> Hej {this.props.userName}!</Flex>
                    <Flex fontSize='20px' fontWeight='500' color='black' marginTop='15px' paddingBottom='10px'>
                        Välkommen till företagets översikt.
                    </Flex>
                </Flex>

                <Flex w='100%' center marginTop='40px' shrink={0}>
                    <Flex backgroundColor='darkwhite' borderRadius='60px' width='500px' height='150px'
                        padding='20px 40px'
                    >
                        <Flex column>
                            <Flex fontSize='21px' fontWeight='500' w='100%' marginBottom='10px' hAlignContent='center' whiteSpace='nowrap'> Nuvarande responstid </Flex>
                            <Flex fontSize='36px' fontWeight='bold' hAlignContent='center'
                            >
                                <SVG cacheGetRequests={true} style={{fill: '#404040', width: '42px', height: '42px'}} src='/images/IncomingErrands_M.svg'/>
                                <Flex marginLeft='20px'
                                    color={this.props.avgResponseTime==='N/A'?'lightgrey':'black'}
                                    fontWeight={this.props.avgResponseTime==='N/A'?'500':'bold'}
                                >
                                    {this.props.avgResponseTime}
                                </Flex>

                                </Flex>
                        </Flex>
                        <Flex column paddingLeft='40px' grow position='relative'>
                            <Flex fontSize='21px' fontWeight='500' w='100%' marginBottom='10px' hAlignContent='center'> Mål </Flex>
                            <Flex fontSize='36px' fontWeight='bold' hAlignContent='center' whiteSpace='nowrap'> {DateTime.convertSecondsToHour(this.props.companyResponseTime)}</Flex>
                            {this.props.userRole !== 'employee' && (
                                <Flex position='absolute' bottom='-15px' right={0}>
                                    <SVGButton src='images/Settings_M.svg' hover='blue'
                                        color='black'
                                        height='60px'
                                        showConfirm={true}
                                        confirmTitle='Mål för responstid'
                                        confirmContent={
                                            (<Flex w='100%' center h='200px' column >
                                                <Flex fontSize='28px' fontWeight='300' color='#333333' marginBottom='34px'>
                                                Ställ in vilken responstid ni vill ha som mål.
                                                </Flex>
                                                <Flex borderRadius='30px' border='3px solid #f0f0f0' w='360px' h='70px' center color='black'>
                                                    <Flex h='30px' w='80px' fontSize='36px' fontWeight='bold' center position='relative' marginRight='10px'>
                                                        <input
                                                            className={style.InputResponseTime}
                                                            type='number'
                                                            value={hours}
                                                            max='99'
                                                            min='0'
                                                            onChange={(e)=>{
                                                                if(e.target.value < 0) return 0
                                                                if(e.target.value > 99) return 99
                                                                this.setState({companyResponseTime: time + (e.target.value-hours)*3600})}
                                                            }
                                                        />
                                                        <Flex position='absolute' right='19px'>h</Flex>
                                                    </Flex>

                                                    <Flex fontSize='36px' fontWeight='bold' center position='relative' marginRight='10px' w='90px'>
                                                    <input
                                                        className={style.InputResponseTime}
                                                        type='number'
                                                        value={minutes}
                                                        onChange={(e)=>{
                                                            if(e.target.value < 0) return 0;
                                                            if(e.target.value > 59) return 59;
                                                            this.setState({companyResponseTime: time + (e.target.value-minutes)*60})}
                                                        }
                                                    />
                                                     <Flex position='absolute' right='17px'>m</Flex>
                                                    </Flex>

                                                    <Flex fontSize='36px' fontWeight='bold' center position='relative' w='80px'>
                                                    <input
                                                        className={style.InputResponseTime}
                                                        type='number'
                                                        value={seconds}
                                                        onChange={(e)=> {
                                                            if(e.target.value < 0) return 0;
                                                            if(e.target.value > 59) return 59;
                                                            this.setState({companyResponseTime: time + (e.target.value-seconds)})}
                                                        }
                                                    />
                                                     <Flex position='absolute' right='23px'>s</Flex>
                                                    </Flex>
                                                </Flex>
                                            </Flex>)
                                        }
                                        confirmButton={{
                                            'src': 'images/Save.svg',
                                            'text': 'Spara'
                                        }}
                                        onClick={()=>{
                                            this.props.dispatch(CompanyModel.update({'response_time': this.state.companyResponseTime}))}
                                        }
                                        onCancel={()=>{
                                            this.setState({companyResponseTime: this.props.companyResponseTime})
                                        }}
                                    />
                                </Flex>
                            )}
                        </Flex>
                    </Flex>

                    <Flex w='50px'/>

                    <Flex backgroundColor='darkwhite' borderRadius='60px' height='150px' w='300px' padding='20px 20px 0 40px' column>
                        <Flex center fontSize='21px' fontWeight='500' w='100%' marginBottom='10px'> Medarbetare online </Flex>
                        <Flex center fontSize='36px' fontWeight='bold'>
                                <SVG cacheGetRequests={true} style={{fill: '#404040', width: '40px', height: '42px'}} src='/images/Employee_M.svg'/>
                                <Flex w='40px'/>{this.props.nbrOnlineEmployee}</Flex>
                    </Flex>
                </Flex>

                <Flex w='100%' center marginTop='40px' shrink={0}>
                    <Flex backgroundColor='darkwhite' borderRadius='60px' width='500px' height='150px'
                        padding='20px 40px'
                    >
                        <Flex column grow>
                            <Flex fontSize='21px' fontWeight='500' w='100%' marginBottom='10px' hAlignContent='center'> Obesvarade ärenden</Flex>
                            <Flex fontSize='36px' fontWeight='bold' hAlignContent='center'>
                                <SVG cacheGetRequests={true} style={{fill: '#404040', width: '42px', height: '42px'}} src='/images/ResponseTime_M.svg'/>
                                <Flex w='40px'/>{this.props.nbrUnassignedTickets}</Flex>
                        </Flex>
                        <Flex column grow paddingLeft='30px'>
                            <Flex fontSize='21px' fontWeight='500' w='100%' marginBottom='10px'> Aktiva ärenden </Flex>
                            <Flex fontSize='36px' fontWeight='bold'>
                                <SVG cacheGetRequests={true} style={{fill: '#404040', width: '42px', height: '42px'}} src='/images/Conversations_M.svg'/>
                                <Flex w='40px'/>
                                {this.props.nbrActiveTickets}
                            </Flex>
                        </Flex>
                    </Flex>

                    <Flex w='50px'/>

                    <Flex backgroundColor='darkwhite' borderRadius='60px' height='150px' w='300px' padding='20px 20px 0px 40px' column>
                        <Flex fontSize='21px' fontWeight='500' w='100%' marginBottom='10px'> Besökare på hemsidan </Flex>
                        <Flex fontSize='36px' fontWeight='bold' center>
                            <SVG cacheGetRequests={true} style={{fill: '#404040', width: '42px', height: '42px'}} src='/images/Visitor_M.svg'/>
                            <Flex w='40px'/>{this.props.nbrOnlineCustomers}</Flex>
                    </Flex>
                </Flex>
            </React.Fragment>

        )
    }

    ___renderArrowButton(label, unit, leftAction, rightAction){
        return (
            <Flex column fontWeight='500' hAlignContent='center' vAlignContent='bottom' h='55px' width='85px' shrink={0}>
                <Flex paddingBottom='3px' h='23px'> {label} </Flex>
                <Flex center>
                    <Arrow
                        direction='left'
                        onClick={leftAction}
                        hover='darkblue' size='small'
                        position='relative'
                        left='10px'/>

                    <Flex vAlignContent='bottom' hAlignContent='center' lineHeight='20px' px='5px'>
                            {unit}
                    </Flex>
                    <Arrow direction='right' onClick={rightAction} hover='darkblue' size='small'
                    position='relative'
                    right='11px'
                    />
                </Flex>
            </Flex>
        )
    }
    ____renderYearActivityButton(){
        let config = this.state.ticketCreatedConfig['info']
        let year = config['year']
        let nxtY, preY;
        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketCreatedButtonOnClick('year', {'year': preY})
        let rightYear= this.__ticketCreatedButtonOnClick('year', {'year': nxtY})
        return this.___renderArrowButton('År', year, leftYear, rightYear)
    }
    ____renderWeekActivityButton(){
        let config = this.state.ticketCreatedConfig['info']
        let week = config['week']
        let year = config['year']

        let preY, preW, nxtY, nxtW;

        preY = year
        preW = week -1
        if(preW === 0){
            preY -= 1
            preW = 53
        }

        nxtY = year
        nxtW= week + 1
        if(nxtW === 54){
            nxtY+=1
            nxtW=1
        }
        let leftWeek = this.__ticketCreatedButtonOnClick('week', {'year': preY, 'week': preW})
        let rightWeek = this.__ticketCreatedButtonOnClick('week', {'year': nxtY, 'week': nxtW})
        let weekButton = this.___renderArrowButton('Vecka', week, leftWeek, rightWeek)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketCreatedButtonOnClick('week', {'year': preY, 'week': week})
        let rightYear= this.__ticketCreatedButtonOnClick('week', {'year': nxtY, 'week': week})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{weekButton}{yearButton}</React.Fragment>
    }
    ____renderMonthActivityButton(){
        let config = this.state.ticketCreatedConfig['info']
        let month = config['month']
        let year = config['year']

        let preY, preM, nxtY, nxtM;

        preY = year
        preM = month -1
        if(preM === 0){
            preY -= 1
            preM = 12
        }

        nxtY = year
        nxtM = month + 1
        if(nxtM === 13){
            nxtY += 1
            nxtM = 1
        }
        let leftMonth = this.__ticketCreatedButtonOnClick('month', {'year': preY, 'month': preM})
        let rightMonth = this.__ticketCreatedButtonOnClick('month', {'year': nxtY, 'month': nxtM})
        let monthButton = this.___renderArrowButton('Månad', month, leftMonth, rightMonth)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketCreatedButtonOnClick('month', {'year': preY, 'month': month})
        let rightYear= this.__ticketCreatedButtonOnClick('month', {'year': nxtY, 'month': month})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{monthButton}{yearButton}</React.Fragment>
    }
    ____renderDayActivityButton(){
        let config = this.state.ticketCreatedConfig['info']
        let day = config['day']
        let month = config['month']
        let year = config['year']

        let currentDay, preD, nxtD;
        let preY, preM, nxtY, nxtM;

        currentDay = new Date(year + ' ' + month + ' ' + day)
        preD = new Date(currentDay)
        preD.setDate(currentDay.getDate()-1)

        preM = preD.getMonth() + 1
        preY = preD.getFullYear()
        preD = preD.getDate() // 31

        nxtD = new Date(currentDay)
        nxtD.setDate(currentDay.getDate()+1)
        nxtM = nxtD.getMonth() + 1
        nxtY = nxtD.getFullYear()
        nxtD = nxtD.getDate()

        let leftDay = this.__ticketCreatedButtonOnClick('day', {'year': preY, 'month': preM, 'day': preD})
        let rightDay = this.__ticketCreatedButtonOnClick('day', {'year': nxtY, 'month': nxtM, 'day': nxtD})
        let dayButton = this.___renderArrowButton('Dag', day, leftDay, rightDay)

        preY = year
        preM = month -1
        if(preM === 0){
            preY -= 1
            preM = 12
        }

        nxtY = year
        nxtM = month + 1
        if(nxtM === 13){
            nxtY += 1
            nxtM = 1
        }
        let leftMonth = this.__ticketCreatedButtonOnClick('day', {'year': preY, 'month': preM, 'day': day})
        let rightMonth = this.__ticketCreatedButtonOnClick('day', {'year': nxtY, 'month': nxtM, 'day': day})
        let monthButton = this.___renderArrowButton('Månad', month, leftMonth, rightMonth)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketCreatedButtonOnClick('day', {'year': preY, 'month': month, 'day': day})
        let rightYear= this.__ticketCreatedButtonOnClick('day', {'year': nxtY, 'month': month, 'day': day})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{dayButton}{monthButton}{yearButton}</React.Fragment>
    }
    __renderUnitButtonForActivityGraph(){
        let ticketReadData = this.props.ticketRead.toJS()
        let unit = this.state.ticketCreatedConfig['unit']
        let buttons = null;
        let year = this.state.ticketCreatedConfig['info']['year']
        let month= this.state.ticketCreatedConfig['info']['month']
        let week = this.state.ticketCreatedConfig['info']['week']
        let day= this.state.ticketCreatedConfig['info']['day']
        switch (unit){
            case 'year':
                buttons = this.____renderYearActivityButton()
                break
           case 'month':
                buttons = this.____renderMonthActivityButton()
               break;
           case 'week':
               buttons = this.____renderWeekActivityButton()
              break
          case 'day':
          default:
               buttons = this.____renderDayActivityButton()
              break
        }
        let fileNameFormatter = ()=>{
            switch(unit){
                case 'day':
                  return day + '/' + DateTime.getMonthByIndex(month-1) + '/' + year
                case 'month':
                  return DateTime.getMonthByIndex(month-1) +'/'+year
                case 'week':
                  return ' V.' + week+'/' + year
                case 'year':
                default:
                    return year
            }
        }
        return (
            <Flex column color='black' fontSize='20px' w='100%'>
                <Flex fontSize='36px' color='black' fontWeight='300' marginBottom='6px' w='100%' center>
                    <Flex grow>
                    <SVG cacheGetRequests={true}style={{fill: '#404040', width: '42px', height: '42px', marginRight: '10px'}} src='/images/Conversations_M.svg'/>
                    Aktivitet
                    </Flex>
                    <CSVLink  target="_self" data={ticketReadData} filename={"Aktivitet-"+fileNameFormatter()+'.csv'}>
                        <Flex width='100%' height='40px' hAlignContent='right' color='black' hover='blue'>
                            <SVG cacheGetRequests={true}style={{fill: 'currentColor', width: '40px', height: '27px'}} src='/images/Download_M.svg'/>
                        </Flex>
                    </CSVLink>
                 </Flex>
                <Flex w='100%'>
                    {buttons}
                    <Flex grow hAlignContent='right' vAlignContent='bottom'>
                    <TextButton text='Dygn'
                        fontSize='20px'
                        active={this.state.ticketCreatedConfig.unit === 'day'}
                        onClick={this.__ticketCreatedButtonOnClick('day', {
                        'year': new Date().getFullYear(),
                        'month': new Date().getMonth() + 1,
                        'day': new Date().getDate(),
                    })}/>
                    <TextButton text='Vecka'
                        fontSize='20px'
                        active={this.state.ticketCreatedConfig.unit === 'week'}
                        onClick={
                        this.__ticketCreatedButtonOnClick('week', {
                            'year': new Date().getFullYear(),
                            'week': DateTime.getCurrentWeek()
                        })
                    }/>
                    <TextButton
                        fontSize='20px'
                        active={this.state.ticketCreatedConfig.unit === 'month'}
                        text='Månad' onClick={this.__ticketCreatedButtonOnClick('month', {
                        'year': new Date().getFullYear(),
                        'month': new Date().getMonth() + 1
                    })}/>
                    <TextButton
                        fontSize='20px'
                        active={this.state.ticketCreatedConfig.unit === 'year'}
                        text='År' onClick={this.__ticketCreatedButtonOnClick('year', {
                        'year': new Date().getFullYear()
                    })}/>
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    __ticketCreatedButtonOnClick(unit, info){
        return ()=>{
            this.props.dispatch(CompanyModel.statsTicketCreatedReadExact(unit, info));
            this.setState({ticketCreatedConfig: {
                'unit': unit,
                'info': info
            }})
        }
    }
    _ActivityGraph(){
        let ticketReadData = this.props.ticketRead.toJS()
        let unitButton = this.__renderUnitButtonForActivityGraph()
        let unit = this.state.ticketCreatedConfig['unit']
        let year = this.state.ticketCreatedConfig['info']['year']
        let month= this.state.ticketCreatedConfig['info']['month']
        let week = this.state.ticketCreatedConfig['info']['week']
        let day= this.state.ticketCreatedConfig['info']['day']
        let getUnit = ()=>{
            switch (unit){
                case 'year':
                    return year
               case 'month':
                    return  DateTime.getMonthByIndex(month-1, true)
               case 'week':
                    return 'vecka ' + week
              case 'day':
              default:
                    return day + ' ' + DateTime.getMonthByIndex(month-1)
            }
        }
        let getTick= ()=>{
            switch (unit){
                case 'year':
                    return 'månad'
               case 'month':
                    return 'dag'
               case 'week':
                    return 'dag'
              case 'day':
              default:
                    return 'timme'
            }
        }

        let dataSum = 0
        for(var dataPoint in ticketReadData){
            dataSum += ticketReadData[dataPoint]['count'];
        }
        let dataAvg = Math.round(dataSum*10/ticketReadData.length)/10
        return (
            <Flex
            w='70%' column position='relative'
            marginTop='30px' padding='20px 40px' backgroundColor='darkwhite'
            borderRadius='60px' shrink={0}>
                <Flex marginBottom='20px'>
                    {unitButton}
                    <Flex paddingTop='50px' paddingRight='20px' grow hAlignContent='right'>
                    </Flex>
                </Flex>
                <Flex position='relative' hostRef={el=>{this.activityGraph = el}}>
                    <ResponsiveContainer width='100%' height={250}>
                        <AreaChart data={ticketReadData} margin={{right: 24}}>
                              <CartesianGrid strokeDasharray="1 1" />
                              <XAxis
                                dataKey={(dataPoint)=>{
                                  let unit = this.state.ticketCreatedConfig.unit
                                  let dateString = dataPoint['time']
                                  switch(unit){
                                      case 'year':
                                        return DateTime.getMonth(dateString)
                                      case 'month':
                                        return DateTime.getSingleDate(dateString)
                                      case 'week':
                                        return DateTime.getDayOfTheWeek(dateString)
                                      case 'day':
                                        return DateTime.getHour(dateString)
                                      default:
                                        return DateTime.getNiceDate(dataPoint['time'])

                                  }
                              }}
                              interval={0}

                              >
                              </XAxis>
                              <YAxis dataKey='count' allowDecimals={false}
                              domain={['dataMin', dataMax => Math.round(dataMax + dataMax*0.25)]}


                              />
                              <Tooltip
                                contentStyle={{borderRadius: '10px'}}
                                formatter={(value)=>value+ 'st'}
                                separator=': '
                                labelFormatter={(value)=> {
                                    let unit = this.state.ticketCreatedConfig.unit
                                    switch(unit){
                                        case 'day':
                                          return value + ':00'
                                        case 'month':
                                          return value + ' ' + DateTime.getMonthByIndex(this.state.ticketCreatedConfig['info']['month']-1)
                                        case 'week':
                                          return value + ' v.' + this.state.ticketCreatedConfig['info']['week']
                                        case 'year':
                                            return value + ' '+ this.state.ticketCreatedConfig['info']['year']
                                        default:
                                            return value
                                    }
                                }}
                                />
                              <Area type="monotone" dataKey="count" stroke="#1984b3" name='Ärenden' fill='#2ea2d2'/>


                        </AreaChart>
                    </ResponsiveContainer>
                    <Flex position='absolute' right='30px' top='10px' color='black' column hAlignContent='right'>
                        <Flex fontSize='20px' fontWeight='bold'>Genomsnitt för {getUnit()}:</Flex>
                        <Flex fontSize='20px' fontWeight='bold'>{dataAvg} ärenden / {getTick()}</Flex>
                    </Flex>
                </Flex>
            </Flex>
        )
    }

    ____renderYearResponseButton(){
        let config = this.state.ticketResponseConfig['info']
        let year = config['year']
        let nxtY, preY;
        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketResponseButtonOnClick('year', {'year': preY})
        let rightYear= this.__ticketResponseButtonOnClick('year', {'year': nxtY})
        return this.___renderArrowButton('År', year, leftYear, rightYear)
    }
    ____renderWeekResponseButton(){
        let config = this.state.ticketResponseConfig['info']
        let week = config['week']
        let year = config['year']

        let preY, preW, nxtY, nxtW;

        preY = year
        preW = week -1
        if(preW === 0){
            preY -= 1
            preW = 53
        }

        nxtY = year
        nxtW= week + 1
        if(nxtW === 54){
            nxtY+=1
            nxtW=1
        }
        let leftWeek = this.__ticketResponseButtonOnClick('week', {'year': preY, 'week': preW})
        let rightWeek = this.__ticketResponseButtonOnClick('week', {'year': nxtY, 'week': nxtW})
        let weekButton = this.___renderArrowButton('Vecka', week, leftWeek, rightWeek)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketResponseButtonOnClick('week', {'year': preY, 'week': week})
        let rightYear= this.__ticketResponseButtonOnClick('week', {'year': nxtY, 'week': week})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{weekButton}{yearButton}</React.Fragment>
    }
    ____renderMonthResponseButton(){
        let config = this.state.ticketResponseConfig['info']
        let month = config['month']
        let year = config['year']

        let preY, preM, nxtY, nxtM;

        preY = year
        preM = month -1
        if(preM === 0){
            preY -= 1
            preM = 12
        }

        nxtY = year
        nxtM = month + 1
        if(nxtM === 13){
            nxtY += 1
            nxtM = 1
        }
        let leftMonth = this.__ticketResponseButtonOnClick('month', {'year': preY, 'month': preM})
        let rightMonth = this.__ticketResponseButtonOnClick('month', {'year': nxtY, 'month': nxtM})
        let monthButton = this.___renderArrowButton('Månad', month, leftMonth, rightMonth)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketResponseButtonOnClick('month', {'year': preY, 'month': month})
        let rightYear= this.__ticketResponseButtonOnClick('month', {'year': nxtY, 'month': month})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{monthButton}{yearButton}</React.Fragment>
    }
    ____renderDayResponseButton(){
        let config = this.state.ticketResponseConfig['info']
        let day = config['day']
        let month = config['month']
        let year = config['year']

        let currentDay, preD, nxtD;
        let preY, preM, nxtY, nxtM;

        currentDay = new Date(year + ' ' + month + ' ' + day)
        preD = new Date(currentDay)
        preD.setDate(currentDay.getDate()-1)

        preM = preD.getMonth() + 1
        preY = preD.getFullYear()
        preD = preD.getDate() // 31

        nxtD = new Date(currentDay)
        nxtD.setDate(currentDay.getDate()+1)
        nxtM = nxtD.getMonth() + 1
        nxtY = nxtD.getFullYear()
        nxtD = nxtD.getDate()

        let leftDay = this.__ticketResponseButtonOnClick('day', {'year': preY, 'month': preM, 'day': preD})
        let rightDay = this.__ticketResponseButtonOnClick('day', {'year': nxtY, 'month': nxtM, 'day': nxtD})
        let dayButton = this.___renderArrowButton('Dag', day, leftDay, rightDay)

        preY = year
        preM = month -1
        if(preM === 0){
            preY -= 1
            preM = 12
        }

        nxtY = year
        nxtM = month + 1
        if(nxtM === 13){
            nxtY += 1
            nxtM = 1
        }
        let leftMonth = this.__ticketResponseButtonOnClick('day', {'year': preY, 'month': preM, 'day': day})
        let rightMonth = this.__ticketResponseButtonOnClick('day', {'year': nxtY, 'month': nxtM, 'day': day})
        let monthButton = this.___renderArrowButton('Månad', month, leftMonth, rightMonth)

        preY = year - 1
        nxtY = year + 1
        let leftYear= this.__ticketResponseButtonOnClick('day', {'year': preY, 'month': month, 'day': day})
        let rightYear= this.__ticketResponseButtonOnClick('day', {'year': nxtY, 'month': month, 'day': day})
        let yearButton = this.___renderArrowButton('År', year, leftYear, rightYear)
        return <React.Fragment>{dayButton}{monthButton}{yearButton}</React.Fragment>
    }
    __renderUnitButtonForResponseGraph(){
        let responseData = this.props.ticketsResponseTime.toJS()
        let unit = this.state.ticketResponseConfig['unit']
        let year = this.state.ticketResponseConfig['info']['year']
        let month= this.state.ticketResponseConfig['info']['month']
        let week = this.state.ticketResponseConfig['info']['week']
        let day= this.state.ticketResponseConfig['info']['day']
        let buttons = null;
        switch (unit){
            case 'year':
                buttons = this.____renderYearResponseButton()
                break
           case 'month':
                buttons = this.____renderMonthResponseButton()
               break;
           case 'week':
               buttons = this.____renderWeekResponseButton()
              break
          case 'day':
          default:
               buttons = this.____renderDayResponseButton()
              break
        }
        let fileNameFormatter = ()=>{
            switch(unit){
                case 'day':
                  return day + '/' + DateTime.getMonthByIndex(month-1) + '/' + year
                case 'month':
                  return DateTime.getMonthByIndex(month-1) +'/'+year
                case 'week':
                  return 'V.' + week +'/' + year
                case 'year':
                default:
                    return year
            }
        }
        return (
            <Flex column color='black' fontSize='20px' w='100%'>
                <Flex fontSize='36px' color='black' fontWeight='300' marginBottom='6px' w='100%'>
                    <Flex grow>
                        <SVG cacheGetRequests={true} style={{fill: '#404040', width: '42px', height: '42px', marginRight: '10px'}} src='/images/IncomingErrands_M.svg'/>
                        Responstid
                    </Flex>
                    <CSVLink target="_self" data={responseData} filename={"Responsetid-"+fileNameFormatter()+'.csv'}>
                        <Flex width='100%' height='40px' hAlignContent='right' hover='blue' color='black'>
                            <SVG cacheGetRequests={true}style={{fill: 'currentColor', width: '40px', height: '27px'}} src='/images/Download_M.svg'/>
                        </Flex>
                    </CSVLink>
                </Flex>
                <Flex  w='100%'>
                    {buttons}
                    <Flex grow hAlignContent='right' vAlignContent='bottom'>
                        <TextButton text='Dygn'
                            fontSize='20px'
                            active={this.state.ticketResponseConfig.unit === 'day'}
                            onClick={this.__ticketResponseButtonOnClick('day', {
                            'year': new Date().getFullYear(),
                            'month': new Date().getMonth() + 1,
                            'day': new Date().getDate(),
                        })}/>
                        <TextButton text='Vecka'
                            fontSize='20px'
                            active={this.state.ticketResponseConfig.unit === 'week'}
                            onClick={
                            this.__ticketResponseButtonOnClick('week', {
                                'year': new Date().getFullYear(),
                                'week': DateTime.getCurrentWeek()
                            })
                        }/>
                        <TextButton
                            fontSize='20px'
                            active={this.state.ticketResponseConfig.unit === 'month'}
                            text='Månad' onClick={this.__ticketResponseButtonOnClick('month', {
                            'year': new Date().getFullYear(),
                            'month': new Date().getMonth() + 1
                        })}/>
                        <TextButton
                            fontSize='20px'
                            active={this.state.ticketResponseConfig.unit === 'year'}
                            text='År' onClick={this.__ticketResponseButtonOnClick('year', {
                            'year': new Date().getFullYear()
                        })}/>
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    __ticketResponseButtonOnClick(unit, info){
        return ()=>{
            this.setState({ticketResponseConfig: {
                'unit': unit,
                'info': info
            }})
            this.props.dispatch(CompanyModel.statsTicketResponseTimeReadExact(unit, info));
        }
    }

    _ResponseGraph(){
        let unitButton = this.__renderUnitButtonForResponseGraph()
        let target = parseInt(this.props.companyResponseTime, 10)
        let responseData = this.props.ticketsResponseTime.toJS()

        let dataSum = 0
        let dataLength = 0
        // transform the dataPoint to diff instead of absolute height
        responseData.forEach( (dataPoint, index) => {
            let responseTimes = dataPoint['second']
            let sum = 0
            for(var t in responseTimes){
                sum += responseTimes[t][0]
                dataLength += 1
            }
            dataSum += sum

            let diff = sum!==0? Math.floor(sum/responseTimes.length - target):0
            responseData[index]['second'] = diff
        })
        let dataAvgResponseTime = Math.round(dataSum*10/dataLength)/10

        let unit = this.state.ticketResponseConfig['unit']
        let year = this.state.ticketResponseConfig['info']['year']
        let month= this.state.ticketResponseConfig['info']['month']
        let week = this.state.ticketResponseConfig['info']['week']
        let day= this.state.ticketResponseConfig['info']['day']
        let getUnit = ()=>{
            switch (unit){
                case 'year':
                    return year
               case 'month':
                    return DateTime.getMonthByIndex(month-1, true)
               case 'week':
                    return 'vecka ' + week
              case 'day':
                    return day+' '+DateTime.getMonthByIndex(month-1)
              default:
                    return 'Dag'
            }
        }
        const gradientOffset = () => {
            const dataMax = Math.max(...responseData.map((i) => i.second));
            const dataMin = Math.min(...responseData.map((i) => i.second));
            if (dataMax <= 0){
  	             return 0
            } else if (dataMin >= 0){
  	             return 1
            } else{
  	             return dataMax / (dataMax - dataMin);
            }
        }
        const off = gradientOffset();
        return (
        <Flex
            position='relative'
            w='70%' column marginTop='30px'
            padding='20px 40px' backgroundColor='darkwhite'
            borderRadius='60px' shrink={0} marginBottom='20px'>
            <Flex marginBottom='20px'>
                {unitButton}
            </Flex>
            <Flex>
            <ResponsiveContainer width='100%' height={250}>
            <AreaChart data={responseData} margin={{right: 24}}>
                  <CartesianGrid strokeDasharray="1 1" />
                  <defs>
                    <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
                    <stop offset={off} stopColor="#ff9894" stopOpacity={1}/>
                    <stop offset={off} stopColor="#9bdc99" stopOpacity={1}/>
                    </linearGradient>
                </defs>
                  <XAxis dataKey={(dataPoint)=>{
                      let unit = this.state.ticketResponseConfig.unit
                      let dateString = dataPoint['time']
                      switch(unit){
                          case 'year':
                            return DateTime.getMonth(dateString)
                          case 'month':
                            return DateTime.getSingleDate(dateString)
                          case 'week':
                            return DateTime.getDayOfTheWeek(dateString)
                          case 'day':
                            return DateTime.getHour(dateString)
                          default:
                            return DateTime.getNiceDate(dataPoint['time'])

                        }
                    }}
                    interval={0}
                  >

                  </XAxis>
                  <YAxis dataKey='second' tickFormatter={(nbr)=>{
                      return DateTime.convertSecondsToHour(nbr+target)
                  }}
                    domain={[-target, dataMax => {
                      if(target > dataMax){
                          return Math.round(target*1.25)
                      }
                      return Math.round(dataMax*1.25)
                    }]}

                  />
                  <Tooltip separator=''
                  labelFormatter={(value)=> {
                      let unit = this.state.ticketResponseConfig.unit
                      switch(unit){
                          case 'day':
                            return value + ':00'
                          case 'month':
                            return value + ' ' + DateTime.getMonthByIndex(this.state.ticketResponseConfig['info']['month']-1)
                          case 'week':
                            return value + ' v.' + this.state.ticketResponseConfig['info']['week']
                          case 'year':
                              return value + ' '+ this.state.ticketResponseConfig['info']['year']
                          default:
                              return value
                      }
                  }}
                   formatter= {(value)=>DateTime.convertSecondsToHour(value+target)}/>
                  <Area type="monotone" dataKey="second" stroke="#5a5a5a" fill="url(#splitColor)" name=' '/>
            </AreaChart>
            </ResponsiveContainer>
            </Flex>
            <Flex position='absolute' right='70px' top='160px' color='black' column hAlignContent='right'>
                <Flex fontSize='20px' fontWeight='bold'>Genomsnitt för {getUnit()}:</Flex>
                <Flex fontSize='20px' fontWeight='bold'>{dataAvgResponseTime?DateTime.convertSecondsToHour(dataAvgResponseTime)+' / ärende':'Ingen data'}</Flex>
            </Flex>
        </Flex>
    )
    }

    render() {
        const ResponseGraphWithPayment = WithPaymentPermission('stats-responseGraph')(this._ResponseGraph)
        const ActivityGraphWithPayment = WithPaymentPermission('stats-activityGraph')(this._ActivityGraph)
        const FeedbackWithPayment = WithPaymentPermission('helpdesk')(FeedbackOverView)
        const RatingStatisticsWithPayment = WithPaymentPermission('stats-rating')(RatingStats)
        return(
            <Flex width='75vw' overflowY='scroll'  onClick={()=>{
                if(this.props.menuToogle) this.props.dispatch(SystemModel.menuToogle(false))
            }}>
                <Flex width='100%' hAlignContent='center' shrink={0} column color='black'>
                    {this._renderLiveStats()}
                    <Flex mt='30px'>
                        <TicketActivity/>
                    </Flex>
                    <Flex width='100%' hAlignContent='center' shrink={0} column hostRef={el => this.componentRef = el}>
                        {<RatingStatisticsWithPayment /> }
                        {this.props.ticketRead.size && <ActivityGraphWithPayment/>}
                        {this.props.ticketsResponseTime.size && <ResponseGraphWithPayment />}
                        <Flex {...statisticsUpgradeText}>
                            <StatisticsUpgradeTextWrapper
                                onClick={() => this.setState({showModal: true})}/>
                        </Flex>
                        <FeedbackWithPayment/>
                    </Flex>
                </Flex>
                <UpgradeModal
                    onClose={() => this.setState({showModal: false})}
                    open={this.state.showModal}
                    onClick={() => history.push("/companySettings/upgrade")}
                    contentType="stats"/>
            </Flex>
        );
    }
}


export default connect((state) => {
    let ticketRead = state.getIn(['company','stats', 'ticketCreated', 'payload'], List())
    let liveStats = state.getIn(['company','stats', 'live', 'payload'], Map())
    let ticketsResponseTime = state.getIn(['company','stats', 'response', 'payload'], List())

    let companyResponseTime = state.getIn(['company', 'info', 'response_time'])

    let nbrOnlineEmployee = EmployeeSelector.getOnlineCoworkers(state).size
    let nbrUnassignedTickets = ConversationSelector.unassignedTickets(state).size

    let nbrOnlineCustomers = liveStats.get('nbr_online_customers')

    let nbrActiveTickets = liveStats.get('nbr_active_tickets')

    let avgResponseTime = liveStats.getIn(['avgs', 0, 'second'], List()).toJS()
    let sum = 0
    for(var t in avgResponseTime){
        sum += avgResponseTime[t][0]
    }
    avgResponseTime = sum===0?'N/A':DateTime.convertSecondsToHour(Math.floor(sum/avgResponseTime.length));

    let userName = UserSelector.getName(state)
    let userRole = UserSelector.getRole(state)

    let menuToogle = state.getIn(['system', 'menu', 'toogle'])

    return {
        ticketRead, nbrOnlineEmployee, nbrUnassignedTickets, nbrOnlineCustomers, nbrActiveTickets, avgResponseTime,
        companyResponseTime, ticketsResponseTime, userName, userRole, menuToogle
    }
})(DashboardOverview)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Overview/index.js